import { useMutation, useQuery } from "react-query";
import { fetchItem, postItem, putItem } from "../queries/queries-helper";
import ENDPOINTS from "../services/endpoints.ts";
import ProjectLockDto from "../models/interfaces/dtos/project-lock-dto.ts";

export const useProjectLock = (projectId: string) => {
    const projectLockStatusQuery = useQuery(
        ["project-lock-status", projectId],
        async () => fetchItem<ProjectLockDto>(ENDPOINTS.PROJECT_LOCK_STATUS(projectId))
    );

    const addLockMutation = useMutation({
        mutationFn: () => postItem<boolean>(ENDPOINTS.PROJECT_LOCK_ADD(projectId), null)
    });
    
    const removeLockMutation = useMutation({
        mutationFn:() => putItem<boolean>(ENDPOINTS.PROJECT_LOCK_REMOVE(projectId), null)
    });

    return {
        lockStatusQueryResult: projectLockStatusQuery,
        addLockMutation,
        removeLockMutation
    }
}

export default useProjectLock;